import { ComplexValue } from 'app/types-shared';
import { findNestedSelectOption } from 'app/components/code-selector/fullscreen-code-selector';

export const buildBreadcrumbs = (codeItems: ComplexValue<number>[], rawBreadcrumbs: number[]): ComplexValue<number>[] => {
  if (!rawBreadcrumbs || rawBreadcrumbs.length === 0) {
    return [];
  }

  const resultBreadcrumbs = rawBreadcrumbs
    .filter(item => findNestedSelectOption({ value: 0, descendants: codeItems }, item) !== null)
    .reduce((breadcrumbs, _, index, filteredRawBreadcrumbs) => {
      const breadcrumbItemPath = findNestedSelectOption(breadcrumbs[index], filteredRawBreadcrumbs[index]);

      const breadcrumbItem = breadcrumbItemPath && breadcrumbItemPath.length > 0 ?
        breadcrumbItemPath[breadcrumbItemPath.length - 1] : undefined;

      return [...breadcrumbs, breadcrumbItem].filter(item => item);
    }, [{ value: 0, descendants: codeItems }]);

  return resultBreadcrumbs ? resultBreadcrumbs.splice(1, resultBreadcrumbs.length) : [];
};
